import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiStar } from 'react-icons/fi';

const reviews = [
  {
    name: "Emily R.",
    text: "I feel more consistent now! The mid-day slump is finally gone. I can actually get through my afternoon social events without feeling exhausted.",
    age: "58"
  },
  {
    name: "Jessica T.",
    text: "As a grandmother, this has been a game changer for my afternoon energy. I actually have the stamina to keep up with my grandkids now.",
    age: "62"
  },
  {
    name: "Amanda M.",
    text: "Love that it's plant-based. I feel so much more vibrant and I don't get the jitters like I did with other things I tried.",
    age: "65"
  }
];

const Testimonials = () => {
  return (
    <section className="my-16 bg-white py-8 border-t border-b border-slate-100">
      <h3 className="text-2xl font-bold text-center text-slate-900 mb-8">
        Other Women Are Loving It Too
      </h3>
      <div className="grid gap-6 md:grid-cols-3">
        {reviews.map((review, idx) => (
          <div key={idx} className="bg-slate-50 p-6 rounded-2xl border border-slate-100 shadow-sm">
            <div className="flex text-amber-400 mb-3">
              {[...Array(5)].map((_, i) => (
                <SafeIcon key={i} icon={FiStar} className="fill-current text-lg" />
              ))}
            </div>
            <p className="text-slate-700 italic mb-4">"{review.text}"</p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-teal-100 text-teal-700 rounded-full flex items-center justify-center font-bold">
                {review.name.charAt(0)}
              </div>
              <div className="text-sm">
                <p className="font-bold text-slate-900">{review.name}</p>
                <p className="text-slate-500">Age {review.age} • Verified</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <p className="text-center text-xs text-slate-400 mt-6">* Individual results may vary.</p>
    </section>
  );
};

export default Testimonials;